import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { PluginInjectorService } from '../plugin-injector.service'
import { IWidget } from '../widget/widget.interface'
import { IModuleWidget } from './dynamic-module-widget-interface'
import { IDynamicWidgetSettingComponent } from './dynamic-widget-components.interface'
import { ModelService } from '../../models'


@Injectable({
  providedIn: 'root'
})
export class DynamicModuleWidgetLoaderService {
  private dynamicModuleWidgets: IModuleWidget[] = []

  // Add components which is required by adding a widget
  addModuleWidget(widgetModule: IModuleWidget): void {
    this.dynamicModuleWidgets.push(widgetModule)
  }

  // Get components that display a widget
  getModuleWidgets(): IModuleWidget[] {
    return this.dynamicModuleWidgets
  }

  // Clear Array
  resetModuleWidgets(): void {
    this.dynamicModuleWidgets.length = 0
  }

  // open setting component of a widget (Dialog component)
  async openDynamicDialogComponent(widget: IWidget, settingComponent: IDynamicWidgetSettingComponent, modelService: ModelService, pluginInjectorService: PluginInjectorService, dialog: MatDialog) {
    let dialogConfig = pluginInjectorService.getMenuDialogConfig();
    if (settingComponent?.dialogConfig?.width) {
      dialogConfig.width = settingComponent.dialogConfig.width
    }

    const appPluginWidget = await modelService._appPluginWidget.getById(widget.appPluginWidget._id)

    if ('_id' in appPluginWidget) {
      widget.appPluginWidget = appPluginWidget
      dialog.open(settingComponent.component, {
        ...dialogConfig,
        data: {
          appPluginWidget: widget.appPluginWidget,
          pluginId: widget.pluginId,
          pluginModule: widget.pluginModule,
          widgetPermissions: widget?.widgetPermissions
        } as IWidget
      })
    }
  }
}
